import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ConfigurationService } from 'src/app/components/core/_infrastructure/classes/services/configuration.service';
import { TogglerService } from 'src/app/components/core/_infrastructure/classes/services/toggler.service';

@Component({
    selector: 'app-login-cas',
    templateUrl: './login-cas.component.html',
    styleUrls: ['./login-cas.component.scss'],
})
export class LoginCASComponent extends ComponentBase implements OnInit, OnDestroy {
    showCASUrlKeyValue: string;
    urlCAS: string;
    visibilityIniciando: boolean = false;
    arrobaClaveEnabled = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        protected authService: AuthService,
        protected notificationService: NotificationService,
        private configurationService: ConfigurationService,
        protected exceptionHandler: ExceptionManager,
        private togglerService: TogglerService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnDestroy(): void {
        this.togglerService.loginPanelVisibility(false);
    }

    ngOnInit() {
        this.configurationService.getCASWebShowCASUrl().subscribe(res => {
            this.showCASUrlKeyValue = res;
        });

        this.configurationService.getCASWebServerName().subscribe(s => {
            this.configurationService.getCASWebLoginUrl().subscribe(t => {
                this.urlCAS = this.getUrlCAS(t, s);
            });
        });

        this.configurationService.getArrobaClaveEnabled().subscribe(result => {
            this.arrobaClaveEnabled = result?.toLocaleLowerCase() === 'true'; // Averiguamos si la autenticación vía Cl@ve está habilitada
        });

        this.togglerService.loginPanelVisibility(true);

        this.createForm();
    }

    createForm() {
        this.form = this.fb.group({
            IdentificadorUsuario: ['', Validators.compose([Validators.required, CustomValidator.NIFValidator])],
            Password: ['', Validators.required],
        });
    }

    getUrlCAS(url: string, serverName: string) {
        return url + '?service=' + encodeURIComponent(serverName).toLowerCase();
    }

    onLoginEnter(event: KeyboardEvent) {
        if (event.code === 'Enter') {
            this.onLogin();
        }
    }

    onLogin() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilityIniciando = true;

        this.authService.login(this.form.value.IdentificadorUsuario, this.form.value.Password).subscribe({
            next: res => {
                this.visibilityIniciando = false;
                if (res) {
                    this.addSuccessMessage('Sesión iniciada');
                    this.router.navigate(['/home']);
                } else {
                    this.addErrorMessage('Error de autorización');
                    this.router.navigate(['/error/loginko']);
                }
            },
            error: error => {
                this.catchServerError(error);
                this.visibilityIniciando = false;
            },
        });
    }
}
